"use strict";

module.exports = function () {
	var set, iterator, result;
	if (typeof Set !== "function") return false;
	set = new Set(["raz", "dwa", "trzy"]);
	if (String(set) !== "[object Set]") return false;
	if (set.size !== 3) return false;
	if (typeof set.add !== "function") return false;
	if (typeof set.clear !== "function") return false;
	if (typeof set.delete !== "function") return false;
	if (typeof set.entries !== "function") return false;
	if (typeof set.forEach !== "function") return false;
	if (typeof set.has !== "function") return false;
	if (typeof set.keys !== "function") return false;
	if (typeof set.values !== "function") return false;

	iterator = set.values();
	result = iterator.next();
	if (result.done !== false) return false;
	if (result.value !== "raz") return false;

	return true;
};
